import(/* webpackMode: "eager" */ "/home/vsts/work/r1/a/_Whimstay-travel-agent/src/app/global-error.tsx");
